export const API_BASE = {
  localhost: '',
  sandbox: 'https://tomcat-qa-public.bostonglobe.com',
  prod: 'https://api.bostonglobe.com',
};



// WEBPACK FOOTER //
// ./src/constants/urls.js